import { useAsyncExecutor } from "async-executor-hook";
import { SelectButton } from "primereact/selectbutton";
import { useContext, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import LogoBBVAWhite from "../../images/bbva_white.svg";
import LogoBCPWhite from "../../images/bcp_white.svg";
import LoadingSpinner from "../../images/loading_gray.gif";
import LoadingGray from "../../images/loading_gray.gif";
import LogoBBVA from "../../images/logo_BBVA.svg";
import LogoBCP from "../../images/logo_BCP.svg";
import LogoInterbank from "../../images/logo_INTERBANK.svg";
import LogoInterbankWhite from "../../images/logo_INTERBANKWHITE.svg";
import LogoNacion from "../../images/logo_NACION.svg";
import LogoNacionWhite from "../../images/logo_NATIONWhite.png";
import LogoScotiabank from "../../images/logo_SCOTIABANK.svg";
import LogoScotiabankWhite from "../../images/logo_SCOTIABANKWHITE.svg";
import {
  BANKS,
  CURRENCIES,
  FILE_FORMATS,
  getCurrencyObject,
} from "../../utils/constants";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import Select from "../Select/Select";
import {
  Container,
  DivIsLoading,
  DivSelectMoney,
  IconButton,
  MainButton,
  Row,
} from "./ContadoMethodStyles";
import FileUploadInputDirectMethod from "./FileUploadInputDirectMethod";

const ContadoMethodAddNewVoucher = (props) => {
  const {
    loadUpfrontManual,
    closeModalNewVoucher,
    setShowModalErrorContadoMethod,
    setShoModalMessageContadoMethod,
    updateShowModal,
    onSuccessData,
    selectedFiles,
    selectMyFile,
    onFileChange,
    setSelectedFiles,
  } = props;
  const [bank, updateBank] = useState(null);
  const [useDollars, updateUseDollars] = useContext(CurrencyContext);
  const [currency, updateCurrency] = useState(
    getCurrencyObject(useDollars).value
  );

  const onCurrencyChange = (e) => {
    updateCurrency(e.target.value);
    updateUseDollars(e.target.value === "pen" ? false : true);
  };
  const itemTemplate = (option) => {
    let image = "";
    switch (option.value) {
      case BANKS.bcp.code:
        image = bank?.code === BANKS.bcp.code ? LogoBCPWhite : LogoBCP;
        break;
      case BANKS.bbva.code:
        image = bank?.code === BANKS.bbva.code ? LogoBBVAWhite : LogoBBVA;
        break;
      case BANKS.interbank.code:
        image =
          bank?.code === BANKS.interbank.code
            ? LogoInterbankWhite
            : LogoInterbank;
        break;
      case BANKS.scotiabank.code:
        image =
          bank?.code === BANKS.scotiabank.code
            ? LogoScotiabankWhite
            : LogoScotiabank;
        break;
      case BANKS.nacion.code:
        image = bank?.code === BANKS.nacion.code ? LogoNacionWhite : LogoNacion;
        break;
      default:
        break;
    }
    return (
      <IconButton
        selected={bank ? bank.code === BANKS[option.value].code : false}
      >
        <img src={image} alt="bcp" />
      </IconButton>
    );
  };

  const saveContadoDocuments = useAsyncExecutor(
    async (params: any) => {
      const { bank, currency, selectMyFile } = params;
      const upfrontManualDetails = {
        bank_option: bank.code,
        payment_currency: currency,
        name_doc: selectMyFile[0].name,
        size_doc: selectMyFile[0].size,
        selectMyFile: selectMyFile,
      };
      return upfrontManualDetails;
    },
    {
      onSuccess: (data, params) => {
        onSuccessData({ data, params });
        setSelectedFiles([]);
        closeModalNewVoucher();
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setShoModalMessageContadoMethod(errorMessage);
        setShowModalErrorContadoMethod(true);
        updateShowModal(false);
      },
    }
  );
  const filterBank =
    loadUpfrontManual.isSuccess &&
    bank &&
    loadUpfrontManual.data.upfront_manual_bank_options.find(
      (bankBack) => bankBack.option === bank.code
    );
  return (
    <Container>
      <h1>Agregar nuevo comprobante</h1>
      <div className="currency--container">
        <DivSelectMoney>
          SELECCIONE MONEDA DE VOUCHER DE COMPROBANTE
        </DivSelectMoney>
        <Select
          className="clickable-element"
          onChange={onCurrencyChange}
          height="4.5rem"
          width="100%"
          arrowPosition="1.6rem"
          value={currency}
        >
          {CURRENCIES.filter((currency) => {
            return !(bank?.code === "nacion" && currency.value !== "pen");
          }).map((currencyElem, index) => (
            <option key={index} value={currencyElem.value}>
              {currencyElem.label}
            </option>
          ))}
        </Select>
      </div>
      <div className="rows-wrapper">
        <Row>
          <div className="row-title">
            <p>Seleccione un banco:</p>
          </div>
          <div className="bank-selectors">
            {loadUpfrontManual.isLoading && (
              <DivIsLoading>
                <img src={LoadingGray} className="icon" alt="Loading screen" />
              </DivIsLoading>
            )}
            {loadUpfrontManual.isSuccess && (
              <SelectButton
                className="bank-styles-select-button"
                value={bank?.code}
                options={loadUpfrontManual.data.upfront_manual_bank_options.map(
                  (bank) => {
                    return {
                      label: bank.name,
                      value: bank.option,
                    };
                  }
                )}
                onChange={(e) => {
                  updateBank(BANKS[e.value]);
                  if (e.target.value === "nacion") {
                    updateCurrency("pen");
                  }
                }}
                itemTemplate={itemTemplate}
              />
            )}
          </div>
          {bank && filterBank && (
            <div className="bank-numbers">
              <div>
                <h2>NÚMERO DE CUENTA BANCARIA</h2>
                <p>
                  {bank && filterBank
                    ? currency === "usd"
                      ? filterBank.usd_accout_number
                      : filterBank.pen_accout_number
                    : "-"}
                </p>
              </div>
              <div>
                <h2>NÚMERO DE CUENTA INTERBANCARIA</h2>
                <p>
                  {bank && filterBank
                    ? currency === "usd"
                      ? filterBank.usd_interbank_account_code
                      : filterBank.pen_interbank_account_code
                    : "-"}
                </p>
              </div>
            </div>
          )}
        </Row>
        <Row>
          <div className="row-title">
            <p>Subir comprobante:</p>
          </div>

          <FileUploadInputDirectMethod
            maxFiles={1}
            onValueChange={onFileChange}
            value={selectedFiles}
            formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
            width={"100%"}
            height={"10.3rem"}
            description="Arrastra el documento para subirlo, o haz click para seleccionar uno. Extensiones válidas: .jpg .png .pdf"
            disabled={saveContadoDocuments.isLoading}
          />
        </Row>
      </div>
      <div>
        <Authorization actions={["invoice.create_invoice_upfront_manual"]}>
          <MainButton
            onClick={() => {
              saveContadoDocuments.execute({
                selectedFiles,
                bank,
                currency,
                selectMyFile,
              });
            }}
            disabled={
              !bank ||
              !bank.code ||
              selectedFiles.length < 1 ||
              saveContadoDocuments.isLoading
            }
            isLoading={saveContadoDocuments.isLoading}
          >
            {saveContadoDocuments.isLoading && (
              <img
                src={LoadingSpinner}
                className="icon"
                alt="Processing request"
              />
            )}
            Guardar comprobante
          </MainButton>
        </Authorization>
      </div>
    </Container>
  );
};

export default ContadoMethodAddNewVoucher;
